// extracted by mini-css-extract-plugin
export default {"sectionHeader":"AuditSection_sectionHeader__bDSBM"};